/* Quick Buy home: Pet Doors. Dog / Cat switch re-tunes needs, picks, best sellers, seasonal card and guides.
   Speed fix 19 Oct 2026: products arrive as a small JSON list (script[data-qbh-data]); cards are built only when shown. */
(() => {
  if (customElements.get('qb-home')) return;
  const STORE = 'qbh-pet';
  const SAFE = /^[a-z0-9-]+$/;
  const SVG = 'http://www.w3.org/2000/svg';
  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };
  const icon = (name) => {
    const svg = document.createElementNS(SVG, 'svg');
    svg.setAttribute('class', 'qbc-ic');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    const use = document.createElementNS(SVG, 'use');
    use.setAttribute('href', '#qbc-ic-' + (SAFE.test(name) ? name : 'other'));
    svg.appendChild(use);
    return svg;
  };
  const MAX_NEEDS = 8;
  const RAIL_MAX = 24;
  const SIZES = '(min-width: 990px) 18vw, (min-width: 750px) 28vw, 42vw';
  const esc = (v) => String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  const atW = (url, w) => (/[?&]width=\d+/.test(url) ? url.replace(/([?&])width=\d+/, '$1width=' + w) : url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w);
  const readData = (root) => {
    const s = root && root.querySelector('script[data-qbh-data]');
    if (!s) return [];
    try {
      const list = JSON.parse(s.textContent);
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  };
  const PAGE = 250;
  const KNOWN = ['costumes', 'clothing', 'toys', 'treats-chews', 'health-calming', 'grooming', 'home-cleaning', 'beds-furniture', 'walk-travel'];

  class QbHome extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const S = window.Shopify || {};
      this.root = (S.routes && S.routes.root) || '/';
      this.currency = (S.currency && S.currency.active) || 'USD';
      try {
        this.best = JSON.parse(this.dataset.best || '[]').map(String);
      } catch (e) {
        this.best = [];
      }
      this.wrap = this.closest('.shopify-section') || this.parentElement;
      this.cards = [];
      this.byId = new Map();
      this.addData(readData(this.wrap));
      this.querySelectorAll('[data-card]').forEach((n) => {
        const c = this.byId.get(n.dataset.id);
        if (c) {
          c.n = n;
        } else {
          const nc = this.card(n, this.cards.length);
          this.cards.push(nc);
          this.byId.set(nc.id, nc);
        }
      });
      this.pageSize = this.cards.length;
      this.needs = Array.from(this.querySelectorAll('[data-need]'));
      this.needBox = this.q('[data-needs]');
      this.rail = this.q('[data-rail]');
      this.grid = this.q('[data-best-grid]');
      this.fill = this.q('[data-best-fill]');
      this.pool = this.q('[data-pool]');
      const bt = this.q('[data-best-title]');
      this.bestBase = bt ? bt.textContent.replace(/ for dogs$/, '') : '';
      this.seasonLive = this.inWindow(this.q('[data-season-card]'));
      this.pet = 'd';
      const pressed = this.needs.find((b) => b.getAttribute('aria-pressed') === 'true');
      this.need = pressed ? pressed.dataset.need : '';

      this.addEventListener('click', (e) => {
        const petBtn = e.target.closest('button[data-pet]');
        if (petBtn && this.contains(petBtn)) {
          this.more();
          this.setPet(petBtn.dataset.pet, true);
          return;
        }
        const needBtn = e.target.closest('button[data-need]');
        if (needBtn && this.contains(needBtn)) {
          this.more();
          this.need = needBtn.dataset.need;
          this.render();
          return;
        }
        const add = e.target.closest('[data-add]');
        if (add && this.contains(add)) {
          this.add(add);
          return;
        }
        if (e.target.closest('[data-view-cart]')) this.viewCart();
      });

      let saved = null;
      try {
        saved = window.localStorage.getItem(STORE);
      } catch (e) {
        saved = null;
      }
      if (saved === 'c' || saved === 'd') this.pet = saved;
      this.render();
      /* The rest of the catalogue (page 2+) loads after the page has finished loading, or on first tap. */
      const later = () => (window.requestIdleCallback ? window.requestIdleCallback(() => this.more(), { timeout: 4000 }) : setTimeout(() => this.more(), 2000));
      if (document.readyState === 'complete') later();
      else window.addEventListener('load', later, { once: true });
    }

    more() {
      if (!this.loading) this.loading = this.loadMore();
      return this.loading;
    }

    addData(list) {
      let added = 0;
      list.forEach((d) => {
        if (!d || !d.id) return;
        const id = String(d.id);
        if (this.byId.has(id)) return;
        const c = {
          n: null,
          d,
          i: this.cards.length,
          id,
          pets: d.p || 'dc',
          aisle: d.a || '',
          aisleName: d.n || '',
          price: Number(d.r) || 0,
          season: d.s === '1',
          rank: this.best.indexOf(id)
        };
        this.cards.push(c);
        this.byId.set(id, c);
        added++;
      });
      return added;
    }

    /* Same markup as snippets/qb-home-card.liquid */
    build(d) {
      const icon = SAFE.test(d.o || '') ? d.o : 'other';
      let media = '';
      if (d.img) {
        const ow = Number(d.w) || 0;
        const oh = Number(d.h) || 0;
        let ws = [200, 300, 400, 500].filter((x) => !ow || x <= ow);
        if (!ws.length) ws = [ow];
        const w = ow ? Math.min(500, ow) : 500;
        const h = ow && oh ? Math.round((w * oh) / ow) : '';
        const srcset = ws.map((x) => atW(d.img, x) + ' ' + x + 'w').join(', ');
        media = '<img src="' + esc(d.img) + '" alt="" srcset="' + esc(srcset) + '" width="' + w + '"' + (h ? ' height="' + h + '"' : '') + ' loading="lazy" sizes="' + SIZES + '" class="qbh-card__img">';
      } else {
        media = '<svg class="qbc-ic qbh-card__ph" aria-hidden="true" focusable="false"><use href="#qbc-ic-' + icon + '"></use></svg>';
      }
      if (d.b) media += '<span class="qbh-badge">' + esc(d.b) + '</span>';
      let btn;
      if (d.st === 'x') btn = '<button type="button" class="qbh-btn qbh-btn--sm qbh-btn--ghost" disabled>Sold out</button>';
      else if (d.st === 'a') btn = '<button type="button" class="qbh-btn qbh-btn--sm" data-add="' + esc(d.v) + '" data-name="' + esc(d.t) + '" aria-label="Add to cart: ' + esc(d.f || d.t) + '">+ Add</button>';
      else btn = '<a class="qbh-btn qbh-btn--sm qbh-btn--ghost" href="' + esc(d.u) + '" aria-label="Choose options: ' + esc(d.f || d.t) + '">Choose</a>';
      const html =
        '<li class="qbh-card" data-card data-id="' + esc(d.id) + '" data-pets="' + esc(d.p) + '" data-aisle="' + esc(d.a) + '" data-aisle-name="' + esc(d.n) + '" data-price="' + esc(d.r) + '" data-season="' + esc(d.s) + '">' +
        '<a class="qbh-card__media qbc-tone--' + icon + '" href="' + esc(d.u) + '" tabindex="-1" aria-hidden="true">' + media + '</a>' +
        '<a class="qbh-card__title" href="' + esc(d.u) + '">' + esc(d.t) + '</a>' +
        '<div class="qbh-card__foot"><span class="qbh-price"><strong>' + (d.pv ? 'From ' : '') + esc(d.pm) + '</strong>' + (d.ca ? ' <s>' + esc(d.ca) + '</s>' : '') + '</span>' + btn + '</div></li>';
      const t = document.createElement('template');
      t.innerHTML = html;
      return t.content.firstElementChild;
    }

    node(c) {
      if (!c.n && c.d) c.n = this.build(c.d);
      return c.n;
    }

    card(n, i) {
      return {
        n,
        i,
        id: n.dataset.id,
        pets: n.dataset.pets || 'dc',
        aisle: n.dataset.aisle || '',
        aisleName: n.dataset.aisleName || '',
        price: Number(n.dataset.price) || 0,
        season: n.dataset.season === '1',
        rank: this.best.indexOf(n.dataset.id)
      };
    }

    countFor(pet) {
      const counts = {};
      this.cards.forEach((c) => {
        if (c.pets.indexOf(pet) > -1) counts[c.aisle] = (counts[c.aisle] || 0) + 1;
      });
      return counts;
    }

    /* The page lists the first 250 products; the rest load here, from the same section (JSON only), page by page. */
    async loadMore() {
      const sid = this.wrap && this.wrap.id && this.wrap.id.indexOf('shopify-section-') === 0 ? this.wrap.id.slice(16) : '';
      if (!sid || this.pageSize < PAGE) return;
      let added = 0;
      for (let pg = 2; pg <= 20; pg++) {
        try {
          const res = await fetch(this.root + '?section_id=' + encodeURIComponent(sid) + '&page=' + pg, { credentials: 'same-origin' });
          if (!res.ok) break;
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const list = readData(doc);
          added += this.addData(list);
          if (list.length < PAGE) break;
        } catch (e) {
          break;
        }
      }
      if (!added) return;
      this.render(true);
      this.renderQuick();
    }

    renderQuick() {
      const names = this.needs.map((b, i) => ({ s: b.dataset.need, name: b.dataset.name || '', i }));
      this.querySelectorAll('[data-door] .qbh-quick').forEach((box) => {
        const counts = this.countFor(box.closest('[data-door]').dataset.door);
        const first = box.querySelector('a');
        const href = first ? first.getAttribute('href') : '';
        const top = names
          .map((x) => ({ s: x.s, name: x.name, i: x.i, n: counts[x.s] || 0 }))
          .filter((x) => x.n > 0)
          .sort((a, b) => b.n - a.n || a.i - b.i)
          .slice(0, 4);
        if (!top.length) return;
        box.textContent = '';
        top.forEach((x) => {
          const a = el('a', 'qbh-pill');
          if (href) a.setAttribute('href', href);
          a.appendChild(el('span', null, x.name));
          a.appendChild(document.createTextNode(' '));
          a.appendChild(el('span', 'qbh-pill__n', String(x.n)));
          box.appendChild(a);
        });
      });
    }

    q(sel) {
      return this.querySelector(sel);
    }

    /* Event card dates are checked again here, in the store's time zone, so a cached page never shows an event after it ends. */
    inWindow(card) {
      if (!card) return false;
      const m = /^([+-])(\d\d)(\d\d)$/.exec(card.dataset.tzo || '');
      const off = m ? (m[1] === '-' ? -1 : 1) * (Number(m[2]) * 60 + Number(m[3])) : 0;
      const today = Number(new Date(Date.now() + off * 60000).toISOString().slice(0, 10).replace(/-/g, ''));
      const start = Number(card.dataset.start) || 0;
      const end = Number(card.dataset.end) || 0;
      return today >= start && today <= end;
    }

    money(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.currency }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    setPet(pet, save) {
      if (pet !== 'd' && pet !== 'c') return;
      this.pet = pet;
      if (save) {
        try {
          window.localStorage.setItem(STORE, pet);
        } catch (e) {
          /* storage blocked: the choice lasts for this page only */
        }
      }
      this.render();
    }

    setText(sel, text) {
      const n = this.q(sel);
      if (n) n.textContent = text;
    }

    render(keepScroll) {
      const pet = this.pet;
      const word = pet === 'c' ? 'cat' : 'dog';
      const words = word + 's';
      const forPet = (c) => c.pets.indexOf(pet) > -1;

      this.querySelectorAll('button[data-pet]').forEach((b) => {
        const on = b.dataset.pet === pet;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (b.closest('.qbh-door')) b.textContent = (on ? 'Showing ' : 'Show ') + (b.dataset.pet === 'c' ? 'cat' : 'dog') + ' picks';
      });
      this.querySelectorAll('[data-door]').forEach((d) => d.classList.toggle('is-active', d.dataset.door === pet));

      let shown = 0;
      let first = '';
      const visible = [];
      const counts = this.countFor(pet);
      this.needs.forEach((b) => {
        const n = counts[b.dataset.need] || 0;
        const vis = n > 0 && shown < MAX_NEEDS;
        if (vis) {
          shown++;
          visible.push(b.dataset.need);
          if (!first) first = b.dataset.need;
        }
        b.hidden = !vis;
        const t = b.querySelector('[data-n]');
        if (t) t.textContent = n + (n === 1 ? ' item' : ' items');
      });
      if (this.needBox) this.needBox.dataset.count = String(shown);
      if (visible.indexOf(this.need) < 0) this.need = first;
      let needName = '';
      this.needs.forEach((b) => {
        const on = b.dataset.need === this.need;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) needName = b.dataset.name || '';
      });
      this.setText('[data-need-title]', 'Shop by need, for ' + words);
      this.setText('[data-rail-title]', needName + ' for ' + words);
      const all = this.q('[data-rail-all]');
      if (all) all.href = pet === 'c' ? this.dataset.catUrl : this.dataset.dogUrl;

      const picks = this.cards
        .filter((c) => forPet(c) && c.aisle === this.need)
        .sort((a, b) => (a.rank < 0) - (b.rank < 0) || a.price - b.price || a.i - b.i);
      const best = this.cards
        .filter((c) => c.rank > -1 && forPet(c) && picks.indexOf(c) < 0)
        .sort((a, b) => a.rank - b.rank)
        .slice(0, 4);
      const shownPicks = picks.slice(0, RAIL_MAX);
      const placed = new Set(shownPicks.concat(best));
      this.cards.forEach((c) => {
        if (c.n && !placed.has(c) && c.n.parentNode !== this.pool) this.pool.appendChild(c.n);
      });
      if (this.rail) {
        shownPicks.forEach((c) => this.rail.appendChild(this.node(c)));
        if (!keepScroll) this.rail.scrollLeft = 0;
        const sec = this.rail.closest('.qbh-sec');
        if (sec) sec.hidden = picks.length === 0;
      }
      if (this.grid) {
        best.forEach((c) => this.grid.insertBefore(this.node(c), this.fill));
        if (this.fill) this.fill.hidden = best.length >= 4;
        this.setText('[data-best-title]', this.bestBase + ' for ' + words);
      }

      this.renderSeason(forPet, words);
      this.renderGuides(pet, word);
    }

    renderSeason(forPet, words) {
      const title = this.q('[data-season-title]');
      if (!title) return;
      const list = this.seasonLive ? this.cards.filter((c) => c.season && forPet(c)) : [];
      const card = title.closest('.qbh-season');
      if (card) card.hidden = list.length === 0;
      const duo = this.q('[data-duo]');
      if (duo) duo.classList.toggle('qbh-duo--solo', list.length === 0);
      if (!list.length) return;
      const counts = {};
      const names = {};
      list.forEach((c) => {
        counts[c.aisle] = (counts[c.aisle] || 0) + 1;
        names[c.aisle] = c.aisleName;
      });
      const top = Object.keys(counts).sort((a, b) => counts[b] - counts[a]).slice(0, 3);
      const min = Math.min.apply(null, list.map((c) => c.price));
      title.textContent = list.length + ' ' + (this.dataset.seasonName || '') + (list.length === 1 ? ' pick for ' : ' picks for ') + words;
      const parts = top.map((id, i) => (i === 0 ? names[id] : String(names[id]).toLowerCase()));
      this.setText('[data-season-sub]', parts.join(', ') + ' and more, from ' + this.money(min) + '.');
      const box = this.q('[data-season-aisles]');
      if (!box) return;
      box.textContent = '';
      top.forEach((id) => {
        const tile = el('span', 'qbh-mini');
        const ic = el('span', 'qbh-mini__icon qbc-tone--' + (KNOWN.indexOf(id) > -1 ? id : 'other'));
        ic.appendChild(icon(KNOWN.indexOf(id) > -1 ? id : 'other'));
        tile.appendChild(ic);
        tile.appendChild(el('span', 'qbh-mini__name', names[id]));
        tile.appendChild(el('span', 'qbh-mini__n', counts[id] + (counts[id] === 1 ? ' item' : ' items')));
        box.appendChild(tile);
      });
    }

    renderGuides(pet, word) {
      const list = this.q('[data-guides]');
      if (!list) return;
      const score = (li) => (li.dataset.pet === pet ? 0 : li.dataset.pet === 'dc' ? 1 : 2);
      Array.from(list.children)
        .sort((a, b) => score(a) - score(b))
        .forEach((li) => list.appendChild(li));
      list.scrollLeft = 0;
      this.setText('[data-guide-title]', 'Guides for ' + word + ' parents');
    }

    async add(button) {
      const id = button.dataset.add;
      const label = button.dataset.name || '';
      button.setAttribute('aria-busy', 'true');
      try {
        const sections = Array.from(document.querySelectorAll('cart-items-component[data-section-id]')).map((n) => n.dataset.sectionId);
        const res = await fetch(this.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sections.join(',') })
        });
        const json = await res.json();
        if (json.status) {
          this.toast(json.description || json.message || 'Could not add to cart.', false);
          return;
        }
        const cart = await (await fetch(this.root + 'cart.js')).json();
        const drawer = document.querySelector('cart-drawer-component');
        const auto = drawer && drawer.hasAttribute('auto-open');
        if (auto) drawer.removeAttribute('auto-open');
        const ev = new Event('cart:update', { bubbles: true });
        ev.detail = { resource: cart, sourceId: 'qb-home', data: { source: 'qb-home', itemCount: cart.item_count, sections: json.sections || {} } };
        this.dispatchEvent(ev);
        if (auto) drawer.setAttribute('auto-open', '');
        button.textContent = 'Added';
        button.classList.add('is-added');
        this.toast('Added: ' + label, true);
      } catch (e) {
        this.toast('Could not add to cart. Please try again.', false);
      } finally {
        button.removeAttribute('aria-busy');
      }
    }

    toast(text, ok) {
      const t = this.q('[data-toast]');
      if (!t) return;
      this.setText('[data-toast-text]', text);
      const vc = this.q('[data-view-cart]');
      if (vc) vc.hidden = !ok;
      t.hidden = false;
      clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        t.hidden = true;
      }, 3500);
    }

    viewCart() {
      const t = this.q('[data-toast]');
      if (t) t.hidden = true;
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      else window.location.href = this.root + 'cart';
    }
  }

  customElements.define('qb-home', QbHome);
})();